import React from 'react';
import { notification } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import CKEditor from '../../editor/Example';
import { imprimir } from '../../common/funciones/imprimir';
import updateActuacionPorId from '../../../graphql/mutations/contravenciones/updateActuacionPorId.graphql';
import getActuacionPorId from '../../../graphql/querys/contravenciones/getActuacionPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import moment from 'moment';

@compose(
  graphql(updateActuacionPorId, {
    name: 'updateActuacionPorId',
  }),
  graphql(getUsuario, {
    name: 'getUsuario',
  }),
  graphql(getActuacionPorId, {
    options: props => ({
      variables: {
        _id: props.match.params.id,
      },
      fetchPolicy: 'network-only',
    }),
  })
)
class EditarActuacion extends React.Component {
  state = {
    persona: {},
    step: 0,
    textoNota: '',
    guardado: false,
    loading: true,
  };

  onCancel = () => {
    this.setState(
      {
        fase: 0,
      },
      () => {
        this.props.history.goBack();
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('THIS PROPS: ', this.props);
    // console.log('NEXT PROPS: ', nextProps);
    if (
      (!this.props.data.getActuacionPorId || this.props.data.loading) &&
      nextProps.data.getActuacionPorId
    ) {
      if (
        !nextProps.data.getActuacionPorId.textoNota ||
        !nextProps.data.getActuacionPorId.modificable
      ) {
        this.props.history.goBack();
      } else {
        this.setState({
          actuacion: nextProps.data.getActuacionPorId,
          textoNota: nextProps.data.getActuacionPorId.textoNota,
          loading: false,
        });
      }
    }
  }

  onGuardar = html => {
    // console.log('Tengo que guardar...');
    // console.log(html);

    this.props
      .updateActuacionPorId({
        variables: {
          _id: this.state.actuacion._id,
          nuevaActuacion: {
            textoNota: html,
          },
          registro: {
            fecha: moment().toDate(),
            idUsuario: this.props.getUsuario.getUsuario
              ? this.props.getUsuario.getUsuario._id
              : '',
            descripcion: 'Texto de la Actuacion Modificado',
          },
        },
      })
      .then(res => {
        // console.log('Respuesta del actuaciolizar');
        // console.log(res);

        if (res.data.updateActuacionPorId) {
          notification.success({
            message: 'Actuacion Modificada',
            description: 'La actuacion se modificó correctamente',
          });

          this.props.history.goBack();
        }
      })
      .catch(err => {
        console.log('Se ha producido un error');
        console.log(err);
        notification.error({
          message: 'Error al actualizar la actuacion',
          description: 'Se ha producido un error al actualizar la actuacion',
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    // console.log('DATOS:');
    // console.log(this.state);
    // console.log(this.props);

    return (
      <div>
        <CKEditor
          modelo_nota={{ htmlModelo: this.state.textoNota }}
          onImprimir={imprimir}
          onGuardar={this.onGuardar}
          onCancel={this.onCancel}
          accion="visualizar"
        />
      </div>
    );
  }
}

export default withApollo(EditarActuacion);
